import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
var css = {
  "mapCard": "rui-od4Dp",
  "circle": "rui-f2sPy",
  "isFetchingMap": "rui-L1vYr",
  "loader": "rui-E0Gag",
  "mobile": "rui-PtyJN",
  "desktop": "rui-zCTQW"
};
import Loader from '../Loader/Loader';
import Link from '../Link/Link';
import classNames from 'classnames';
var pickParams = function pickParams(props) {
  var acceptedKeys = ['size', 'zoom', 'language', 'scale', 'maptype', 'markers'];
  var params = {
    center: "".concat(props.latitude, ",").concat(props.longitude)
  };
  for (var _i = 0, _Object$keys = Object.keys(props); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    if (acceptedKeys.includes(key)) {
      params[key] = props[key];
    }
  }
  return params;
};
var StaticMap = /*#__PURE__*/function (_React$Component) {
  function StaticMap() {
    _classCallCheck(this, StaticMap);
    return _callSuper(this, StaticMap, arguments);
  }
  _inherits(StaticMap, _React$Component);
  return _createClass(StaticMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _a, _b, _c, _d;
      var params = pickParams(this.props);
      if (!((_b = (_a = this.props).staticMapUrl) === null || _b === void 0 ? void 0 : _b.call(_a, params))) {
        (_d = (_c = this.props).getStaticMapUrl) === null || _d === void 0 ? void 0 : _d.call(_c, params);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this = this;
      var shouldRenewStaticMapUrl = ['latitude', 'longitude', 'size', 'zoom', 'language', 'scale', 'maptype', 'markers'].reduce(function (memo, key) {
        if (memo) {
          return memo;
        }
        return prevProps[key] !== _this.props[key];
      }, false);
      if (shouldRenewStaticMapUrl) {
        prevProps.getStaticMapUrl(pickParams(this.props));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a, _b, _c, _d;
      var map;
      var href;
      var image = ((_b = (_a = this.props).staticMapUrl) === null || _b === void 0 ? void 0 : _b.call(_a, pickParams(this.props))) || '';
      var circleClassName = this.props.circleClassName || css.circle;
      var className = classNames(css.mapCard, _defineProperty({}, circleClassName, this.props.circle));
      var isFetchingMapUrl = (_d = (_c = this.props).isFetching) === null || _d === void 0 ? void 0 : _d.call(_c, pickParams(this.props));
      var dataAutId = this.props.dataAutId;
      if (this.props.hrefToGoogle) {
        href = "https://www.google.com/maps/place/".concat(this.props.latitude, ",").concat(this.props.longitude);
      } else if (this.props.href) {
        href = this.props.href;
      }
      if (isFetchingMapUrl) {
        map = /*#__PURE__*/React.createElement("div", {
          className: css.isFetchingMap,
          "data-aut-id": dataAutId
        }, /*#__PURE__*/React.createElement(Loader, {
          className: css.loader
        }));
      } else if (href) {
        map = /*#__PURE__*/React.createElement("div", {
          className: className,
          "data-aut-id": dataAutId
        }, /*#__PURE__*/React.createElement(Link, {
          to: href
        }, /*#__PURE__*/React.createElement("img", {
          src: image,
          alt: "google map"
        })));
      } else {
        map = /*#__PURE__*/React.createElement("div", {
          className: className,
          onClick: this.props.onClick,
          "aria-hidden": "true",
          "data-aut-id": dataAutId
        }, /*#__PURE__*/React.createElement("img", {
          src: image,
          alt: "google map"
        }));
      }
      return map;
    }
  }]);
}(React.Component);
StaticMap.defaultProps = {
  circle: false,
  circleClassName: '',
  href: '',
  hrefToGoogle: false,
  onClick: function onClick() {},
  size: '640x256',
  zoom: '15',
  language: 'es',
  scale: '1',
  dataAutId: ''
};
export default StaticMap;